import React, {Component} from 'react';
import isMobile from 'ismobilejs';

import {t} from 'l10n';
import { localizeUrl, getLocalizedRoomUrl } from 'components/ReactRouterDomLocalized';

import '../../sass/room.scss';

import RoomUserListItem from './RoomUserListItem';
import {getRoomUserWeight, filterRoomUser} from 'utils/user';
import RoomItemInfoTooltip from './RoomItemInfoTooltip';
import ModalRoomIsFull from '../modals/ModalRoomIsFull';
import {addHashParam as addURLHashParam, isSameRoomURL} from "../../utils/url";

import EnterIcon from "../icon/Enter"
import ExpandIcon from "../icon/Expand"
import CollapseIcon from "../icon/Collapse"

const MAX_USER_ITEMS = 15;
const MAX_USER_ITEMS_SECONDARY = 10;

class RoomItemNeo extends Component {
    constructor(props) {
        super(props);

        let {room} = props;

        this.state = {
            expanded: this.isExpanded(room),
            showRoomIsFull: false,
            showRoomIsFullModal: false
        };

        this._onWindowResize = this._onWindowResize.bind(this);
        this.openRoomFn = this.openRoomFn.bind(this);
        this.getMaxUserItems = this.getMaxUserItems.bind(this);
    }

    _onWindowResize(event) {
        // code
        this.forceUpdate();
    }

    componentDidMount() {
        window.addEventListener('resize', this._onWindowResize);
    }

    componentWillReceiveProps(nextProps) {
        let {room, currentUser} = nextProps;
        this.setState({
            showRoomIsFull: currentUser.isLoggedIn() && !currentUser.isXXL() && room.userCount > room.userLimit
        });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this._onWindowResize);
    }

    isExpanded(room) {
        // todo: make it prop?
        return true;
    }

    openRoomFn(event, url=null, user=null) {
        event.preventDefault();

        let {room} = this.props;
        let {showRoomIsFull} = this.state;

        let room_url = url ? localizeUrl(url) : getLocalizedRoomUrl(room);
        if(user) {
            room_url = addURLHashParam(room_url, "u", btoa(user.ufrag));
            if(user.roomid) room_url = addURLHashParam(room_url, "roomid", user.roomid);
        }

        if (!showRoomIsFull) {
            this.maybeOpenRoom(room_url, 'chat', user);
        } else {
            this.setState({showRoomIsFullModal: true})
        }
    }

    maybeOpenRoom(url, windowname, user) {
        let wnd = window.open('', windowname, 'height=678,width=1200,resizable=1,toolbar=0,scrollbars=0');

            // if we just opened the window
        if (wnd && (wnd.closed || (!wnd.document.URL) || (wnd.document.URL.indexOf("about") === 0) || !isSameRoomURL(url, wnd.document.URL))) {
            wnd.location.href = url;
        } else {
            if (isMobile.apple.device) {
                if(wnd) {
                    wnd.close();
                }
                wnd = window.open(url, windowname);
            } else {
                if(user) {
                    wnd.postMessage({action: 'openVideoWindow', ufrag: user.ufrag, roomid: user.roomid}, "*");
                }
            }
        }

        // return the window
        return wnd;
    }

    userFilterCallback(user) {
        let room = this;

        return filterRoomUser(user, room);
    }

    userSortCallback(user1, user2) {
        // the higher weighted user will be closer to sorted list's start
        return getRoomUserWeight(user1) > getRoomUserWeight(user2) ? -1 : 1;
    }

    getUserItemsPerRow() {
        let result = 5;

        let page_width;
        try {
            page_width = document.body.clientWidth;
        } catch(e) {
            // console.log(e);
            return result;
        }
        
        if(page_width < 329) {
            result = 1;
        } else if(page_width < 679) {
            result = 2;
        } else if(page_width < 1197) {
            result = 3;
        } else if(page_width < 1504) {
            result = 4;
        }

        return result;
    }

    getMaxUserItems() {
        let {room} = this.props;
        let result = room.is_primary ? MAX_USER_ITEMS : MAX_USER_ITEMS_SECONDARY;

        let page_width;
        try {
            page_width = document.body.clientWidth;
        } catch (e) {
            // console.log(e);
            return result;
        }

        if(page_width < 679) {
            result = room.is_primary ? 8 : 4;
        } else if(page_width < 1197) {
            result = room.is_primary ? 9 : 6;
        } else if(page_width < 1504) {
            result = room.is_primary ? 12 : 8;
        }

        return result;
    }

    render() {
        let {room} = this.props;

        let titlePart2 = room.name.replace(/bobTV /i, '');

        let {expanded, showRoomIsFull, showRoomIsFullModal} = this.state;

        let visibleUsers = [];

        if (room.users && room.users.length) {
            visibleUsers = room.users
                .filter(this.userFilterCallback, room)
                .sort(this.userSortCallback)
                .slice(0, this.getMaxUserItems(room));
        }

        let visible_users_count = visibleUsers.length;
        let users_per_row = this.getUserItemsPerRow();
        let placeholder_count = 0;

        if(visible_users_count % users_per_row > 0) placeholder_count = users_per_row - visible_users_count % users_per_row;

        var placeholder_set = [];
        for (var i=0; i < placeholder_count; i++) {
            placeholder_set.push(<div key={"ph" + i} className="stretch-wrapper no-border"><a href={getLocalizedRoomUrl(room)} onClick={this.openRoomFn} title={room.name}></a></div>);
        }

        let classNames = ['room-item', 'neo'];
        if (expanded) classNames.push('expanded');

        // [desktop label, mobile label]
        let openRoomLabels = !showRoomIsFull ? [t('Open this room'), t('Open')] : [t('Room is full'), t('Room is full')];

        return (
            <div className={classNames.join(' ')}>

                {showRoomIsFullModal && <ModalRoomIsFull show={true} closeFn={() => this.setState({showRoomIsFullModal: false})} returnPath={getLocalizedRoomUrl(room)}/>}

                <div className="content">
                    <div className="top">
                        <div className="left-top">
                            <div className="left-top-inner">
                                <span className="title-prefix">BobTV</span>
                                <span className="line"> | </span>
                                <span className="room-name">{titlePart2}</span>
                                <RoomItemInfoTooltip room={room}/>
                            </div>
                        </div>
                        <div className="right-top">
                            <div>
                                <div/>
                                <div className="people">{room.userCount || 0}</div>
                            </div>

                            <a href={getLocalizedRoomUrl(room)} className={'open-room active' + (showRoomIsFull ? ' full' : '')} onClick={this.openRoomFn}>
                                <EnterIcon colorIndex="theme" hoverColorIndex="white"/>
                                <span className="big-screen">{openRoomLabels[0]}</span>
                                <span className="small-screen">{openRoomLabels[1]}</span>
                            </a>

                        </div>
                        <div className="expand">
                            <div className="expand-control" onClick={() => this.setState({expanded: !expanded})}>
                                {expanded ? <CollapseIcon colorIndex="theme"/> :
                                            <ExpandIcon colorIndex="theme"/>}
                            </div>       
                        </div>
                    </div>
                    <div className="snapshot-list">
                        {visibleUsers.map((user, index) =>
                            <RoomUserListItem key={index} user={user} room={room} roomUrl={getLocalizedRoomUrl(room)} onItemClick={this.openRoomFn}/>
                        )}
                        {placeholder_set}
                    </div>
                </div>
            </div>
        )
    }
}

export default RoomItemNeo;


// WEBPACK FOOTER //
// ./src/components/index/RoomItemNeo.js